// FILE: src/components/brand/Wordmark.jsx
// The "Zun Drivers" wordmark (plan WP-8: a wordmark until a logo file
// exists). The mark is a Z drawn as a road; it is decorative, the words
// carry the name for screen readers.
import { Box, Typography } from "@mui/material";

export function BrandMark({ size = 32 }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      sx={{ width: size, height: size, flexShrink: 0, display: "block" }}
    >
      <rect width="64" height="64" rx="14" fill="#1E5B3A" />
      <path d="M18 19h28L19 45h28" fill="none" stroke="#fff" strokeWidth="9" strokeLinejoin="round" strokeLinecap="round" />
      <path
        d="M18 19h28L19 45h28"
        fill="none"
        stroke="#1E5B3A"
        strokeWidth="1.6"
        strokeDasharray="3.5 4"
        strokeLinecap="round"
      />
    </Box>
  );
}

export default function Wordmark({ size = 32, subtitle = "Beginner Driver Education", compact = false }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
      <BrandMark size={size} />
      <Box sx={{ minWidth: 0, lineHeight: 1 }}>
        <Typography
          component="span"
          sx={{ display: "block", fontWeight: 750, fontSize: "1.125rem", letterSpacing: "-0.01em", color: "text.primary", lineHeight: 1.2 }}
        >
          Zun Drivers
        </Typography>
        {!compact && subtitle && (
          <Typography component="span" sx={{ display: "block", color: "text.secondary", fontSize: "1rem", lineHeight: 1.3, whiteSpace: "nowrap" }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
